import { Pill, PILL_COLORS } from "components/ui/Pill";

import { getCdmStatusLabel } from "../../constants/cdmFinder";
import s from "./CdmFinderCells.module.css";

export const CdmStatusPill = ({ status }) => {
  const colors =
    status === "DEREGISTERED" ? PILL_COLORS.reactionUnknown : PILL_COLORS.docNew;

  return <Pill {...colors}>{getCdmStatusLabel(status)}</Pill>;
};

// Probable = found by a clinical code; Possible = found only by a medication /
// baseline signal (KIN-1409 G5).
export const CaseTypePill = ({ caseType }) => {
  if (!caseType) return "-";
  const isProbable = caseType === "PROBABLE";

  return (
    <Pill {...(isProbable ? PILL_COLORS.sentYes : PILL_COLORS.reactionUnknown)}>
      {isProbable ? "Probable" : "Possible"}
    </Pill>
  );
};

const splitCsv = (value) =>
  value
    ? String(value)
        .split(",")
        .map((entry) => entry.trim())
        .filter(Boolean)
    : [];

// Renders why a patient is in the list as a flat set of pills — no category
// headings. Prefers the BE-grouped reasons (`matchReasons` = [{ heading,
// reasons[] }], KIN-1409 G11), flattening every group's reasons into one list.
// The "Age" group is dropped (it has its own dedicated column). Falls back to
// the individual matched* fields for older responses.
export const MatchedCell = ({
  matchReasons,
  matchedConditions,
  prescription,
  matchedLabs,
  matchedBaseline,
}) => {
  const reasonLabels = (matchReasons || [])
    .filter((group) => group.heading?.toLowerCase() !== "age")
    .flatMap((group) => group.reasons || []);

  if (reasonLabels.length) {
    return (
      <div className={s.chips}>
        {reasonLabels.map((reason) => (
          <Pill key={reason} {...PILL_COLORS.method}>
            {reason}
          </Pill>
        ))}
      </div>
    );
  }

  const conditionLabels = (matchedConditions || []).map((condition) =>
    condition.name ? `${condition.code} — ${condition.name}` : condition.code
  );

  const labels = [
    ...conditionLabels,
    ...splitCsv(prescription),
    ...splitCsv(matchedLabs),
    ...(matchedBaseline || []),
  ];

  if (!labels.length) return "-";

  return (
    <div className={s.chips}>
      {labels.map((label) => (
        <Pill key={label} {...PILL_COLORS.method}>
          {label}
        </Pill>
      ))}
    </div>
  );
};
